// API client for the in-app bell preferences (ticket 202-3) and per-event email preferences (202-5).
import { api } from './api';

export const notificationPrefsApi = {
  getBellPrefs: () => api.get('/notifications/prefs').then(r => r.data),
  // `muted` = the event types the user turned off; everything else stays on.
  setBellPrefs: (muted) => api.put('/notifications/prefs', { muted }).then(r => r.data),
  getEmailPrefs: () => api.get('/notifications/email-prefs').then(r => r.data),
  // `prefs` = { event_type: boolean }; keys left out keep their saved value.
  setEmailPrefs: (prefs) => api.put('/notifications/email-prefs', { prefs }).then(r => r.data),
};
